import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=3b5a8b05&scoped=true"
import script from "./Upgrade.vue?vue&type=script&lang=js"
export * from "./Upgrade.vue?vue&type=script&lang=js"
import style0 from "./Upgrade.vue?vue&type=style&index=0&id=3b5a8b05&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a8b05",
  null
  
)

export default component.exports